import React, { useEffect, useState } from "react";
import api from "../api/client";
import UploadImage from "../Components/common/UploadImage";

export default function AboutPage() {
  const [team, setTeam] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/teammembers/Allemployees");
        if (cancelled) return;
        setTeam(Array.isArray(res.data) ? res.data : res.data?.data || []);
        setStatus("ready");
      } catch {
        if (!cancelled) setStatus("error");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="es-page">
      <p className="es-eyebrow">Who we are</p>
      <h1 className="es-h1">Support built around the individual</h1>
      <p className="es-lede">
        EduSpecial brings together speech and language therapists, occupational
        therapists, behaviour analysts and inclusive-education specialists under
        one roof, so families do not have to coordinate care across half a dozen
        separate services.
      </p>

      <section aria-labelledby="approach-heading" style={{ marginBottom: "3rem" }}>
        <h2 className="es-h2" id="approach-heading">
          How we work
        </h2>
        <div className="es-grid">
          {[
            {
              title: "Assessment first",
              body: "Every family starts with a full assessment. Nobody is placed on a programme before we understand what they actually need.",
            },
            {
              title: "One coordinated team",
              body: "Therapists, educators and family-support staff share notes and goals, so progress in one setting carries into the next.",
            },
            {
              title: "Families included",
              body: "Parents and carers are trained alongside the learner, because the hours outside our building are the ones that matter most.",
            },
            {
              title: "Measured openly",
              body: "Goals are written down, reviewed on a schedule, and shared with families in plain language rather than clinical shorthand.",
            },
          ].map((item) => (
            <article key={item.title} className="es-card">
              <div className="es-card__body">
                <h3 className="es-h3">{item.title}</h3>
                <p className="es-body" style={{ fontSize: "0.92rem" }}>
                  {item.body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section aria-labelledby="team-heading">
        <h2 className="es-h2" id="team-heading">
          Our team
        </h2>

        {status === "loading" && (
          <div className="es-grid" aria-busy="true">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="es-card">
                <div className="es-skeleton es-skeleton--card" />
                <div className="es-card__body">
                  <div className="es-skeleton es-skeleton--text" style={{ width: "60%" }} />
                  <div className="es-skeleton es-skeleton--text" style={{ width: "80%" }} />
                </div>
              </div>
            ))}
            <span className="es-visually-hidden">Loading team members</span>
          </div>
        )}

        {status === "error" && (
          <div className="es-alert es-alert--error" role="alert">
            We couldn&rsquo;t load the team list right now.
          </div>
        )}

        {status === "ready" && team.length === 0 && (
          <div className="es-state">
            <p className="es-state__title">No team members listed yet</p>
            <p>Profiles will appear here once they have been added.</p>
          </div>
        )}

        {status === "ready" && team.length > 0 && (
          <div className="es-grid">
            {team.map((member) => (
              <article key={member._id} className="es-card">
                <UploadImage
                  file={member.image}
                  alt={`Portrait of ${member.name}`}
                  style={{ width: "100%", height: "12rem", objectFit: "cover", display: "block" }}
                />
                <div className="es-card__body">
                  <h3 className="es-h3">{member.name}</h3>
                  <p className="es-muted">{member.position}</p>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
